import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AutoSigninPopup = () => {
  const [showModal, setShowModal] = useState(false);

  // Show modal after 60 seconds (once per session) only if user not logged in
  useEffect(() => {
    if (!localStorage.getItem("signinPopupShown")) {
      const timer = setTimeout(() => {
        if (!localStorage.getItem("auth:v1")) {
          setShowModal(true);
          localStorage.setItem("signinPopupShown", "true");
        }
      }, 60000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => setShowModal(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Signed in successfully!");
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div
      className="modal show d-block animate__animated animate__fadeIn"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content rounded-5 shadow-lg overflow-hidden">
          <div className="row g-0">
            {/* LEFT IMAGE */}
            <div className="col-md-6 d-none d-md-block">
              <img
                src="/slider/1.jpeg"
                alt="Aarnayours"
                className="img-fluid h-100 animate__animated animate__fadeInLeft"
                style={{
                  objectFit: "cover",
                }}
              />
            </div>

            {/* RIGHT FORM */}
            <div className="col-md-6 d-flex align-items-center justify-content-center bg-light p-5 animate__animated animate__fadeInRight">
              <div style={{ width: "100%", maxWidth: "400px" }}>
                <h2 className="fw-bold mb-2 text-center">Welcome Back</h2>
                <p className="text-muted text-center mb-4">
                  Sign in to AARNAYOURS
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="email"
                      className="form-control rounded-pill px-4 py-2"
                      placeholder="Email address"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="password"
                      className="form-control rounded-pill px-4 py-2"
                      placeholder="Password"
                      required
                    />
                  </div>
                  <button
                    className="btn btn-warning w-100 rounded-pill fw-bold py-2 mb-3"
                    type="submit"
                  >
                    Sign In
                  </button>
                </form>

                <p className="text-center small">
                  Don’t have an account? <Link to="/signup">Sign Up</Link>
                </p>

                <div className="text-center mt-3">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoSigninPopup;
